<!-- 学员-详情-页面级 -->
<template>
  <div class='mentee-detail'>
    <div class='detail-top'>
      <div class='mentee-info'>
        <img v-if='menteeInfo.headPortrait'
             :src='menteeInfo.headPortrait'
             alt='head sculpture' />
        <img v-else
             src='https://res.zailairen.com/tech/msp/mentor-avatar.svg'
             alt='head sculpture' />
        <div class='mentee-info-right'>
          <h3 class='mentee-name'>{{menteeInfo.enName}}</h3>
          <p class='mentee-desc'>{{menteeInfo.basePackage}} {{menteeInfo.applyInYear}}</p>
        </div>
      </div>
      <ul class='mentee-tabs'>
        <li :class="[activeMentee === item.id ? 'active' : '']"
            v-for='item in menteeList'
            :key='item.id'
            @click="tabMenteeInfo(item)">{{item.name}}</li>
      </ul>
    </div>
    <router-view></router-view>
  </div>
</template>

<script>
import menteeService from '@/api/undergraduate/mentee'
export default {
  name: '',
  components: {},
  data () {
    return {
      // 学员面板
      menteeList: [
        {
          id: 'activity',
          name: 'Activity'
        },
        {
          id: 'school',
          name: 'School'
        },
        {
          id: 'information',
          name: 'Information'
        }
      ],
      // 当前面板
      activeMentee: '',
      // 学员num
      menteeNum: '',
      // 学员详情-基本信息
      menteeInfo: {}
    }
  },
  computed: {},
  mounted () {
    this.activeMentee = this.$route.meta.info
    this.menteeNum = this.$route.params.id
    this.getMenteeDetail()
  },
  methods: {
    // 获取学员详情
    getMenteeDetail () {
      menteeService.menteeDetail({ num: this.menteeNum }).then(res => {
        this.menteeInfo = res.data.model
      }).catch(res => {
        this.$ugd_message(res.message, 'error')
      })
    },
    // 学员面板切换
    tabMenteeInfo (item) {
      this.activeMentee = item.id
      this.$router.push({
        path: `/undergraduate/mentee/${this.menteeNum}/${item.id}`
      })
    }
  }
}
</script>
<style lang='less' scoped>
.clearfix {
  *zoom: 1;
}
.clearfix::after {
  content: "";
  display: block;
  clear: both;
}
.fl {
  float: left;
}
.mentee-detail {
  width: 1240px;
  padding: 20px;
  margin: 0 auto;
  .detail-top {
    background: #ffffff;
    border-radius: 8px;
    padding: 10px 20px 0;
    .mentee-info {
      display: flex;
      img {
        flex: 0 0 60px;
        border: none;
        width: 60px;
        height: 60px;
        border-radius: 60px;
      }
      .mentee-info-right {
        flex: 1;
        padding: 8px 0 8px 20px;
        .mentee-name {
          font-size: 18px;
          color: #323c47;
          letter-spacing: 0;
        }
        .mentee-desc {
          font-size: 14px;
          color: #667483;
          letter-spacing: 0;
        }
      }
    }
    .mentee-tabs {
      text-align: center;
      li {
        display: inline-block;
        font-size: 18px;
        color: #667483;
        letter-spacing: 0;
        text-align: center;
        line-height: 25px;
        position: relative;
        margin: 0 30px;
        padding-bottom: 10px;
        border-bottom: 4px solid #fff;
        cursor: pointer;
        &::after {
          content: "";
          display: block;
          width: 8px;
          height: 8px;
          border-radius: 8px;
          position: absolute;
          right: -20px;
          top: -4px;
        }
        &.active {
          color: #323c47;
          border-bottom: 4px solid #4aa6ff;
          &::after {
            background: #ff612f;
          }
        }
      }
    }
  }
}
</style>
